import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import {
  createLocation,
  CreateLocationPayload,
  deleteLocation,
  updateLocation,
  UpdateLocationPayload,
} from "./locationApi";

export function useUpdateLocationMutation(
  options?: UseMutationOptions<void, unknown, UpdateLocationPayload>,
) {
  return useMutation({
    ...options,
    mutationFn: (payload: UpdateLocationPayload) => {
      return updateLocation(payload);
    },
  });
}

export function useCreateLocationMutation(
  options?: UseMutationOptions<void, unknown, CreateLocationPayload>,
) {
  return useMutation({
    ...options,
    mutationFn: (payload: CreateLocationPayload) => {
      return createLocation(payload);
    },
  });
}

export function useDeleteLocationMutation(
  options?: UseMutationOptions<void, unknown, string>,
) {
  return useMutation({
    ...options,
    mutationFn: (locationUuid: string) => {
      return deleteLocation(locationUuid);
    },
  });
}
